module.exports = __webpack_public_path__ + "static/summary-44fbf5874e30395ded01df9d2212a622.png";